<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div class="topBar"></div>
    <div class="cardTop" v-if="reimburse && submitter">
        <div class="bodyCard">
          <div class="card">
            <div class="titleCard">
              <div class="reimburs">差旅报销</div>
              <div class="claimStatus">{{convertState(reimburse.approvalState)}}</div>
            </div>
            <div class="LRstylebox titleCard">
              <span style="color: black;">{{submitter.staffUserName }}</span>
              <span>提交于{{reimburse.createdAt}}</span>
            </div>
          </div>
        </div>
    </div>
    <el-tabs type="border-card" @tab-click="handleClick">
      <el-tab-pane type="border-card" label="基本信息">
          <div class="bodyCard" >
            <div class="card">
            <div class="line">基本信息</div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple"  v-if="BasicInfo && BasicInfo.length > 0">
                <ul v-for="item in BasicInfo" :key="item.index">
                  <li class="LRstyle">
                    <span>出差目的</span>
                    <span>{{item.AimName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>出差事由</span>
                    <span>{{item.Content}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>成本对象编码</span>
                    <span>{{item.PID}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>成本对象</span>
                    <span>{{item.ProjectName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>是否长差</span>
                    <span>
                      <el-radio v-model="LongApplyFor" label="1" disabled>是</el-radio>
                      <el-radio v-model="LongApplyFor" label="2" disabled>否</el-radio>
                    </span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">
          出差人员
          <span>（{{UserInfo ? UserInfo.length : 0}}）</span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="UserInfo && UserInfo.length>0">
                <ul v-for="item in UserInfo" :key="item.index">
                  <li class="LRstyle">
                    <span>姓名</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>类别</span>
                    <span>{{item.UserType}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>部门</span>
                    <span>{{item.DeptName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>工作基地</span>
                    <span>{{item.WorkPlace}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>电话</span>
                    <span>{{item.Mobile}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">
          城市间交通费
          <span>（{{TrafficFee ? TrafficFee.length : 0}}）</span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="TrafficFee && TrafficFee.length>0">
                <ul v-for="item in TrafficFee" :key="item.index">
                  <li class="LRstyle">
                    <span>人员</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>票据类型</span>
                    <span>{{item.TicketType}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>出发地</span>
                    <span>{{item.StartCity}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>目的地</span>
                    <span>{{item.EndCity}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>出发时间</span>
                    <span>{{item.StartDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>报销金额</span>
                    <span>{{item.Sum}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">
          住宿费用
          <span>（{{HotelFee ? HotelFee.length : 0}}）</span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="HotelFee && HotelFee.length>0">
                <ul v-for="item in HotelFee" :key="item.index">
                  <li class="LRstyle">
                    <span>人员</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>城市</span>
                    <span>{{item.City}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>酒店名称</span>
                    <span>{{item.HotelName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>入住时间</span>
                    <span>{{item.StartDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>离开时间</span>
                    <span>{{item.EndDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>金额</span>
                    <span>{{item.Sum}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>标准金额</span>
                    <span>{{item.SumStandard}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">
          补助费用
          <span>（{{Allowance ? Allowance.length : 0}}）</span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="Allowance && Allowance.length>0">
                <ul v-for="item in Allowance" :key="item.index">
                  <li class="LRstyle">
                    <span>人员</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>开始日期</span>
                    <span>{{item.StartDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>结束日期</span>
                    <span>{{item.EndDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>补助天数</span>
                    <span>{{item.TripDays}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>金额（元）</span>
                    <span>{{item.Sum}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">
          其他费用
          <span>（{{OtherFee ? OtherFee.length : 0}}）</span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="OtherFee && OtherFee.length>0">
                <ul v-for="item in OtherFee" :key="item.index">
                  <li class="LRstyle">
                    <span>人员</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>报销类别</span>
                    <span>{{item.CostCodeName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>月份</span>
                    <span>{{item.CostMonthStub}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>备注</span>
                    <el-tooltip class="item" effect="dark" :content="item.Remark" placement="top">
                    <span class="remark-text">{{item.Remark}}</span>
                    </el-tooltip>
                  </li>
                  <li class="LRstyle">
                    <span>核定金额（元）</span>
                    <span>{{item.Sum}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">
          支付信息
          <span>（{{PaymentInfo ? PaymentInfo.length : 0}}）</span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="PaymentInfo && PaymentInfo.length>0">
                <ul v-for="item in PaymentInfo" :key="item.index">
                  <li class="LRstyle">
                    <span>人员</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>收款账号</span>
                    <span>{{item.PayAccount}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>合计金额</span>
                    <span>{{item.Amount}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>冲抵备用金</span>
                    <span>{{item.ReserveFundsAmount}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>冲抵公司卡</span>
                    <span>{{item.CompanyCardAmount}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>应支付金额</span>
                    <span>{{item.PayAmount}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">附件信息</div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div
                class="grid-content bg-purple"
                v-if="fileRepertories && fileRepertories.length>0"
              >
                <span v-for="item in fileRepertories" :key="item.index">
                  <img src v-lazy="item.url" alt="附件信息" class="fileRepertories" />
                </span>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
    </div>
</div>
        <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
          <span>请填写审批意见！</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="审批意见">
        <el-form ref="form" label-width="80px">
            <div class="bodyCard">
                <div class="card">
                    <el-form-item class="label-suggest" label="填写审批意见">
                      <el-input class="indented-input" type="textarea"  v-if="!isDisplay&& TrafficFee && TrafficFee.find(it=>it.IsExceed)"  v-model="approvalOpinion"></el-input>
                      <el-input v-else type="textarea" v-model="suggestion"></el-input>
                    </el-form-item>
                </div>
            </div>
          <el-form-item v-if="!isDisplay">
                <el-button type="text" class="goback">
                    <div @click="onCancel" class="fail-button">
                        <div>取消</div>
                    </div>
                    <div @click="open2" class="success-button">
                        <img src="@/assets/tongyi.png" alt="">
                        <div>同意</div>
                    </div>
                </el-button>
          </el-form-item>
          <el-form-item class="goback" v-if="isDisplay">
                <div @click="onCancel" class="fail-button">
                    <div>取消</div>
                </div>
              <div @click="onReject" class="success-button">
                <img src="@/assets/tongyi.png" alt="">
                <div>拒绝</div>
              </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="审批记录" >
        <div class="bodyCard" style="padding-bottom: 10px;">
        <div class="card">
        <div class="suggest-box info-box">
          <el-row :gutter="10" >
            <div class="block">
                <el-timeline v-if="AuditHistory && AuditHistory.length > 0">
                    <el-timeline-item
                    v-for="(activity, index) in AuditHistory"
                    :key="index"
                    :timestamp="activity.CreateDate"
                    >
                    <div class="container">
                        <div class="row">
                        <span class="label" v-if="activity.UserName">操作人：</span
                        ><span>{{ activity.UserName }}</span>
                        </div>
                        <div class="row" v-if="activity.Status">
                        <span class="label">状态：</span><span>{{ activity.Status }}</span>
                        </div>
                        <div class="row" v-if="activity.Suggestion">
                        <span class="label">备注：</span><span>{{ activity.Suggestion }}</span>
                        </div>
                    </div>
                    </el-timeline-item>
                </el-timeline>
                <div v-else>暂无数据</div>
                </div>
          </el-row>
        </div>
        </div>
    </div>
      </el-tab-pane>
    </el-tabs>
     <el-button type="text" class="goback" v-if="tabId !== 'tab-1'">
         <div class="fail-button"  @click="open3">
             <img src="@/assets/jujue.png" alt="">
             <div>拒绝</div></div>
         <div class="success-button"  @click="onApprove">
             <img src="@/assets/tongyi.png" alt="">
             <div>同意</div></div>
     </el-button>
    </div>
</template>

<script>
import { getApiURL } from "../config"

export default {
  data() {
    return {
      id: this.$route.query.id,
      List: [],
      BasicInfo: [],
      TrafficFee: [],
      HotelFee: [],
      PaymentInfo: [],
      UserInfo: [],
      OtherFee: [],
      Allowance: [],
      AuditHistory: [],
      fileRepertories: [],
      LongApplyFor: "1",
      suggestion: "",
      tabId: "",
      activeIndex: "1",
      activeIndex2: "1",
      centerDialogVisible: false,
      isDisplay:false,
      message: "",
      fullscreenLoading: false,
      approvalOpinion:"已知悉存在超标账目",
      submitter:{},
      reimburse:{}
    };
  },
  methods: {
     convertState (state) {
        switch (state) {
            case -1:
            default:
                return "未提交"
            case 0: return "审批中"
            case 1: return "已通过"
            case 2: return "被驳回"
        }
    },
    getTokenCode(){
        let fs_token = localStorage.fs_token;
        let rxToken = localStorage.rx_token;
        let markType = sessionStorage.markType;
        let doType = sessionStorage.doType;
        let deviceType=sessionStorage.deviceType;//判断他是pc端还是移动端

        let token_type
        let rx_token

        if (markType) {
            if (deviceType==='mobile') {
                token_type='FEI_SHU_TOKEN';// 审批
                rx_token=fs_token;
            }else if(deviceType==='pc'){
                token_type='UNIFIED_OFFICE_TODO';
                rx_token=rxToken;
            }
            if (!doType) {
                token_type='UNIFIED_OFFICE_TODO';//即使通信 统一办公pc
                rx_token=rxToken;
            }
        } else {
            if (rxToken) {
                token_type='RUI_XIN';
                rx_token=rxToken;
            }else{//作废
                token_type='FEI_SHU_TOKEN';
                rx_token=fs_token;
            }
        }

        return { token_type, rx_token };
    },
    getToken(){
        let fs_token = localStorage.fs_token;
        let rxToken = localStorage.rx_token;//zhbg_tk
        let markType = sessionStorage.markType;
        let deviceType=sessionStorage.deviceType;
        let doType = sessionStorage.doType;

        let token_type
        let rx_token

        if (markType) {
            if (deviceType==='mobile') {
                token_type='FEI_SHU_CODE';// 审批
                rx_token=fs_token;
            }else if(deviceType==='pc'){
                token_type='UNIFIED_OFFICE_TODO';// pc
                rx_token=rxToken;
            }
            if (!doType) {
                token_type='UNIFIED_OFFICE_TODO';//即使通信 统一办公pc
                rx_token=rxToken;
            }
        } else {
            if (rxToken) {
                token_type='RUI_XIN';
                rx_token=rxToken;
            }else{//废弃
                token_type='FEI_SHU_CODE';
                rx_token=fs_token;
            }
        }

        return { token_type, rx_token };
    },
    getFeishu(){
    // 获取 URL 中的参数
    const urlParams = new URLSearchParams(window.location.search);
    let code = urlParams.get('code');

        if (code) {
          // 存储授权码
            localStorage.setItem("fs_token", code);
          // 处理授权码
          this.getDetail();
          // 删除 code 参数并保留其他参数
          urlParams.delete('code');
          const newQueryString = urlParams.toString();
          const newUrl = `${window.location.origin}${window.location.pathname}${newQueryString ? '?' + newQueryString : ''}`;
          // 更新浏览器地址栏中的 URL，但不刷新页面
          window.history.replaceState({}, document.title, newUrl);
        } else {
            // 构建授权 URL
            const redirectUri = encodeURIComponent(window.location.href);
            const appId = 'cli_a6d43c60a2f8d366';
            const state = 'STATE'

             const authUrl=`https://open.fklzl.cnpc.com.cn/open-apis/authen/v1/authorize?app_id=${appId}&redirect_uri=${redirectUri}&state=${state}`
            // 重定向到授权页面
            window.location.href = authUrl;
        }
    },
    setMarkType() {
        let markType = sessionStorage.markType;
        let platform = sessionStorage.platform;
        let deviceType=sessionStorage.deviceType;
        if (markType) {
            if (deviceType==='mobile') {//审批
                this.$loading({
                $loading: true,
                text: '保存成功'
                })
                setTimeout(() => {
                tt.closeWindow()
                }, 1500)
            }else if(deviceType==='pc'){
                this.$loading({
                $loading: true,
                text: '保存成功'
                })
                setTimeout(() => {
                  window.close()
                }, 1500)
            }
            if (platform) {//即时通信
                this.$loading({
                $loading: true,
                text: '保存成功'
                })
                setTimeout(()=>{
                    wx.closeWindow();
                },1500)
            }else{//pc
                this.$loading({
                $loading: true,
                text: '保存成功'
                })
                setTimeout(()=>{
                    window.close();
                },1500)
            }

        } else {
            this.$loading({
                $loading: true,
                text: '同步待办处理中'
            })
            setTimeout(() => {
                window.location.replace("https://app.cnpc.com.cn:8443/rxshared/private_todo/");
            }, 3000)
        }
    },
        //驳回审批
        onReject() {
            let rootUrl = getApiURL("")
            let FlowId = localStorage.FlowId;
            let suggest = this.suggestion;

            const ret = this.getTokenCode();

            const params = {
                ...ret,
                p_code: "RFCAIWU",
                encrypted: "1",
                data: {
                    ComType: "AuditReturn",
                    FlowID: FlowId,
                    Suggestion: suggest
                }
            }
            this.$http({
                method: "post",
                dataType: "jsonp",
                url:
                    rootUrl +
                    "/process?req_data=" +
                    encodeURIComponent(
                        JSON.stringify(params)
                    )
            }).then(res => {
              this.setMarkType();
            })
        },
        //退回审批
        onCancel() {
            document.getElementById("tab-0").click();
        },
        // 通过进审批意见
        onApprove(){
            document.getElementById("tab-1").click();
        },
        open2() {
            this.$confirm("确认通过此业务申请?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info"
            }).then(() => {
                let rootUrl = getApiURL("");
                let FlowId = localStorage.FlowId;
                let suggest = (this.TrafficFee&&this.TrafficFee.find(it=>it.IsExceed))?this.approvalOpinion:this.suggestion;
                const ret = this.getTokenCode();
                const params = {
                    ...ret,
                    p_code: "RFCAIWU",
                    encrypted: "1",
                    data: {
                        ComType: "SubmitAudit",
                        FlowID: FlowId,
                        Suggestion: suggest
                    }
                }
                this.$http({
                    method: "post",
                    dataType: "jsonp",
                    url:
                        rootUrl +
                        "/process?req_data=" +
                        encodeURIComponent(
                            JSON.stringify(params)
                        )
                }).then(res => {
                   this.setMarkType();
                })
            }).catch(() => { })
        },
        // 驳回
        open3() {
            this.$confirm("驳回时意见不能为空", "提示", {
                confirmButtonText: "确定",
                type: "info"
            })
                .then(() => {
                    document.getElementById("tab-1").click()
                    this.isDisplay=true;
                })
                .catch(() => { })
        },
        handleClick(tab, event) {
            let $this = this
            $this.isDisplay=false;
            $this.tabId = event.target.id
        },
        getDetail() {
            let $this = this
            let rootUrl = getApiURL("");
            let FlowId = localStorage.FlowId;
            $this.fullscreenLoading = true;
            const ret = this.getToken();

            const params = {
                ...ret,
                p_code: "RFCAIWU",
                encrypted: "1",
                data: {
                    ComType: "GetDetailsOfFlow",
                    FlowID: FlowId,
                    FlowTypeID: 1
                }
            }
            this.$http({
                method: "post",
                dataType: "jsonp",
                url:
                    rootUrl +
                    "/process?req_data=" +
                    encodeURIComponent(
                        JSON.stringify(params)
                    )
            }).then(function (res) {
             $this.fullscreenLoading = false

            let Data = res.data.data;
            if (Data.token) {
            localStorage.setItem("fs_token",Data.token)
            } else {
                localStorage.removeItem('fs_token')
            }

          let obj = {},
            list = new Array(obj);
          obj["AimName"] = Data.BasicInfo.AimName;
          obj["Content"] = Data.BasicInfo.Content;
          obj["PID"] = Data.BasicInfo.PID;
          obj["ProjectName"] = Data.BasicInfo.ProjectName;
          $this.BasicInfo = list;
          $this.PaymentInfo = res.data.data.PaymentInfo;
          $this.UserInfo = res.data.data.UserInfo;
          $this.OtherFee = res.data.data.OtherFee;
          $this.HotelFee = res.data.data.HotelFee;
          $this.Allowance = res.data.data.Allowance;
          $this.TrafficFee = res.data.data.TrafficFee;
          $this.AuditHistory = res.data.data.AuditHistory;
          $this.fileRepertories = res.data.data.fileRepertories;
          $this.LongApplyFor = res.data.data.LongApplyFor == true ? "1" : "2";
          $this.submitter=res.data.data.submitter;
          $this.reimburse=res.data.data.reimburse;
        })
        .catch(function(res) {
          $this.fullscreenLoading = false;
          $this.$router.push({ path: "*" });
        });
    }
  },
    mounted() {
        let rxToken = localStorage.rx_token;
        let doType=sessionStorage.doType;
        let markType=sessionStorage.markType;
        let deviceType=sessionStorage.deviceType;

        if (markType) {
            if (deviceType==='mobile') {//移动端
                this.getFeishu()
            }else if(deviceType==='pc'){
                this.getDetail()
            }
            if (!doType) {//即使通信 统一办公pc端
                this.getDetail()
            }
        }else{
            if (rxToken) {
                this.getDetail()
            } else {//代办应用废弃
                this.getFeishu()
            }
        }

    },
  components: {}
};
</script>

<style>
.el-tooltip__popper{
    max-width: 60%!important;
    text-align: center !important;
    line-height: 18px !important;
    padding: 5px !important;
}
.remark-text {
  display: inline-block !important;
  max-width: 200px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.el-tab-pane{
    margin-bottom: 75px !important;
}
.titleCard{
  margin: 16px !important;
  display: flex;
  align-items: center;
}
.reimburs{
  font-weight: 700;
  font-size: 18px;
  color: #222222;
}
.claimStatus{
  width: 55px;
  background-color: #D8E0FE ;
  display: inline-block;
  font-size: 12px;
  height: 20px;
  text-align: center;
  margin-left: 20px !important;
  line-height: 20px;
  border-radius: 4px;
  color: #2A57D8;
}
.titleName{
  font-size: 14px !important;
  color: #878d !important;
  list-style: none !important;
  display: flex !important;
  justify-content: space-between !important;
  height: 30px !important;
  line-height: 30px !important;
  border-bottom: 1px solid #edf2fc54 !important;
}
.topBar{
    width: 100%;
    height: 120px!important;
    display: flex;
    justify-content: center!important;
    align-items: center!important;
    z-index:1;
    background: linear-gradient(to bottom,#3370fe 0%,#fefefe 120px) !important;
}
.cardTop{
    display: flex;
    justify-content: center!important;
    align-items: center!important;
    margin-top: -80px!important;
    margin-bottom: 10px!important;
    width: 100%;
}

.bodyCard{
    display: flex!important;
    justify-content: center!important;
    align-items: center!important;
    margin: 0;
    margin-top: 20px!important;
    margin-bottom: 10px !important;
    width: 100%;
}
.card {
    width: 87%;
    background: #fff;
    border-radius: 8px;
    margin: 16px auto; /* 增加间距 */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.1) !important;
    transition: box-shadow 0.3s ease-in-out;
    padding: 5px !important;
}

.container {
  width: 100%;
  font-size: 16px;

}
.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
  margin-bottom: 8px !important;
}
.label {
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;
  width: 80px;
}
.el-timeline{
    margin-top: 15px !important;
}
.el-timeline-item__content{
    padding: 0px 30px 8px !important;
}
.el-timeline-item__timestamp{
    padding: 0px 30px 15px !important;
}
.fail-button {
  width: 41%;
  height: 36px!important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  cursor: pointer;
  text-align: center;
  margin-top: 5px  !important;
  font-weight: 500;
  font-size: 14px;
  color: #EB4C54;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #EB4C54;
}
.fail-button img{
    width: 18px;
    margin-right: 5px !important;
}
.success-button img{
    width: 18px;
    margin-right: 5px !important;
}
.success-button{
  width: 41%;
  height: 36px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  font-size: 14px;
  color: #409eff;
  cursor: pointer;
  text-align: center;
  margin-top: 5px  !important;
  font-weight: 500;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #638BDB;
  line-height: 20px;
}

template {
  text-align: center !important;
}
th,
td {
  padding: 5px 0 !important;
}

.buttonCon {
  width: 100% !important;
  text-align: center !important;
  margin: 20px auto !important;
}
.line {
  height: 30px !important;
  line-height: 30px !important;
  text-indent: 15px !important;
  font-weight: 600;
  font-size: 16px;
}
.titleLine{
  background: #ffff !important;
  height: 30px !important;
  line-height: 30px !important;
  color: #222222 !important;
  text-indent: 15px !important;
  font-size: 14px;
}
.LRstylebox{
  font-size: 14px !important;
  color: #878d !important;
  list-style: none !important;
  display: flex !important;
  justify-content: space-between !important;
  height: 30px !important;
  line-height: 30px !important;
}
.LRstyle {
  font-size: 14px !important;
  color: #878d !important;
  list-style: none !important;
  display: flex !important;
  justify-content: space-between !important;
  height: 30px !important;
  line-height: 30px !important;
  border-bottom: 1px solid #edf2fc54 !important;
}
.LRstyle span:first-of-type {
  background: #FFFFFF;
  color: #ABABAB;
}
.LRstyle span:last-of-type {
  background: #FFFFFF;
  color: black;

}
.fileRepertories {
  width: 30% !important;
  height: 100% !important;
  padding: 0 5px !important;
}
.el-tabs__content {
  padding: 0 !important;
}
.el-tabs__content_b {
  padding: 0 !important;
  height: 100vh !important;
}
.label-suggest {
  width: 100% !important;
  text-indent: 5 !important;
}
.goback {
  position: fixed !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 52px !important;
  border: 1px solid #dcdcdc !important;
  background-color: #f7f7f7 !important;
  z-index: 5 !important;
  border-bottom-width: 0 !important;
  padding: 0 !important;
  background: #fff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.1) !important; /* 均匀阴影 */
}
.goback span {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  height: 100% !important;
  border: none !important;
  display: flex !important;
  justify-content: space-around !important;
}

.el-tabs__nav-scroll{
  border-radius: 5px !important;
  display: flex;
  justify-content: space-around;
}
.el-tabs__nav {
  width: 87.5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px !important;
  background-color: #EFF0F2;
  border-radius: 16px;
  font-size: 14px;
  text-align: center;
  line-height: 32px !important;
  padding-left: 4px !important;
  padding-right:4px !important;
}
.el-tabs--border-card{
    border: none !important;
    -webkit-box-shadow:none !important;
    box-shadow: none !important;
}
.el-tabs--border-card>.el-tabs__header{
    border-bottom: 0px !important;
}
.el-tabs__item {
  text-align: center !important;
  font-size: 14px !important;
  padding:  0px 10px !important;
  height: 22px !important;
  line-height: 22px !important;
  text-align: center;
}

.el-tabs__item.is-active{
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
    border-radius: 20px 20px !important;
    padding-bottom: 1px !important;
    font-weight: 550;
}

.el-tabs__header{
  background-color: #fff!important;
}
.el-form-item__label {
  width: 90% !important;
  text-align: left !important;
  height: 20px !important;
  line-height: 20px !important;
  font-size: 14px !important;
  margin: 16px 0px 14px 14px !important;
}
.el-textarea__inner{
    width: 91.5% !important;
    margin-left: 14px !important;
    margin-bottom: 16px !important;
    padding: 16px !important;
     font-family: "Arial", sans-serif;
}
.el-form-item__content {
  width: 100% !important;
  margin: 0 !important;
  display: flex !important;
  justify-content: space-between !important;
}

.el-menu li {
  width: 50% !important;
  text-align: center !important;
  font-size: 18px !important;
}
.cell {
  text-align: center !important;
  font-size: 14px !important;
}
th,
td {
  padding: 5px 0 !important;
}
.el-icon-close {
  display: none !important;
}
.bg-purple ul {
  border-top: 1px solid #ddd !important;
}
.bg-purple ul:first-child {
  border-top: none !important;
}
.suggest-box {
  margin-bottom: 40px !important;
}
.info-box {
  padding: 0 15px !important;
}

.el-message-box__wrapper .el-message-box {
  width: 80% !important;
  height: 100px !important;
}

.el-message-box__wrapper .el-message-box .el-message-box__header {
  padding: 10px !important;
}

.el-message-box__wrapper
  .el-message-box
  .el-message-box__header
  .el-message-box__title
  span {
  font-size: 14px !important;
}

.el-message-box__wrapper .el-message-box .el-message-box__content {
  padding-left: 10px !important;
}

.el-message-box__wrapper .el-message-box .el-message-box__message {
  padding-left: 30px !important;
}

.el-message-box__wrapper .el-message-box .el-message-box__btns button {
  width: 50px !important;
  height: 25px !important;
  margin-right: 10px !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/tripReimbursement.vue